import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import styles from "../../../styles/styles";
import {
    AiFillHeart,
    AiOutlineEye,
    AiOutlineHeart,
    AiOutlineShoppingCart,
} from "react-icons/ai";
import { backend_url } from "../../../server";
import ProductDetailsCard from "../ProductDetailsCard/ProductDetailsCard.jsx";
import { useDispatch, useSelector } from 'react-redux'
import { addToWishlist, removeFromWishlist } from '../../../redux/actions/wishlist';
import { addTocart } from '../../../redux/actions/cart';
import { toast } from 'react-toastify';
import { fetchLiveProductStock } from "../../../utils/productStock";
import { useBuyerAcceptedOfferPrices } from "../../../hooks/useBuyerAcceptedOfferPrices";
import { getProductCardPriceDisplay, getProductListingPrice, buildCartLineForAdd } from "../../../utils/offerPricing";

// Currency formatter for GBP
const formatCurrency = (value) => {
    if (value === null || value === undefined) return "£0.00";
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
    }).format(Number(value));
};

const ProductCard = ({ data, isEvent }) => {
    const { wishlist } = useSelector((state) => state.wishlist);
    const { cart } = useSelector((state) => state.cart);
    const { user, isAuthenticated } = useSelector((state) => state.user);
    const [click, setClick] = useState(false);
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const acceptedOfferPrices = useBuyerAcceptedOfferPrices(user?._id, isAuthenticated);
    const acceptedOfferPrice = acceptedOfferPrices[String(data?._id)] || null;
    const priceDisplay = getProductCardPriceDisplay(data, acceptedOfferPrice);
    const isOwnProduct = isAuthenticated && user && (
        String(user._id) === String(data?.shopId || data?.shop?._id)
    );



    useEffect(() => {
        if (wishlist && wishlist.find((i) => i._id === data._id)) {
            setClick(true);
        } else {
            setClick(false);
        }
    }, [wishlist]);

    // Remove from wish list 
    const removeFromWishlistHandler = (data) => {
        setClick(!click);
        dispatch(removeFromWishlist(data));
    }

    // add to wish list
    const addToWishlistHandler = (data) => {
        if (isOwnProduct) {
            toast.error("You cannot add your own product to wishlist!");
            return;
        }
        setClick(!click);
        dispatch(addToWishlist(data))
    }

    // Add to cart
    const addToCartHandler = async (id) => {
        if (isOwnProduct) {
            toast.error("You cannot buy your own product!");
            return;
        }

        const live = await fetchLiveProductStock(id);
        if (!live.ok) {
            toast.error(live.message || "Product stock limited!");
            return;
        }

        const listingPrice = getProductListingPrice(live.product || data);
        const acceptedUnitPrice = priceDisplay.isAcceptedOffer
            ? priceDisplay.displayPrice
            : null;
        const existing = cart?.find((i) => String(i._id) === String(id));
        const result = buildCartLineForAdd({
            product: live.product || data,
            stock: live.stock,
            qty: 1,
            listingPrice,
            acceptedUnitPrice,
            existingItem: existing,
        });

        if (result.error === "stock") {
            toast.error(
                result.stock > 0
                    ? `Only ${result.stock} available in stock.`
                    : live.message || "Product stock limited!"
            );
            return;
        }
        if (result.error === "bundle_offer") {
            toast.error(
                "This item is in your cart as part of a bundle offer. Adjust quantity in the cart or remove it first."
            );
            return;
        }
        if (result.error === "different_price") {
            toast.error("This item is already in your cart at a different price.");
            return;
        }

        dispatch(addTocart(result.item));
        toast.success(
            result.merged
                ? `Updated to ${result.item.qty} at your accepted offer price.`
                : "Item added to cart successfully!"
        );
    }


    return (
        <>
            <div className='w-full h-[100%] bg-white rounded-lg shadow-sm p-2 sm:p-3 relative cursor-pointer prod-card'>
                <div className='flex justify-end'>
                </div>

                <Link to={`${isEvent === true ? `/product/${data._id}?isEvent=true` : `/product/${data._id}`}`}>
                    <img
                        src={
                            data?.images && data.images.length > 0
                                ? `${backend_url}${data.images[0]}`
                                : (data?.image_Url && data.image_Url[0] && data.image_Url[0].url)
                        }
                        alt="prd"
                        className='w-full h-[110px] sm:h-[145px] lg:h-[170px] object-contain prod-img'
                    />
                </Link>
                <Link to={`/product/${data._id}`}>
                    <h4 className='pb-1 sm:pb-2 text-[12px] sm:text-[14px] font-[500] leading-4 sm:leading-5'>
                        {data.name.length > 38 ? data.name.slice(0, 38) + '...' : data.name}
                    </h4>

                    <div className='py-1 sm:py-2 flex items-center justify-between'>
                        <div className='flex items-end gap-1 sm:gap-2 flex-wrap min-w-0'>
                            <h5 className={`${styles.productDiscountPrice}`}>
                                {formatCurrency(priceDisplay.displayPrice)}
                            </h5>
                            {priceDisplay.strikePrice ? (
                                <h4 className={`${styles.price}`}>
                                    {formatCurrency(priceDisplay.strikePrice)}
                                </h4>
                            ) : null}
                        </div>

                        {/* <span className="font-[400] text-[17px] text-[#68d284]">
                            {data?.sold_out} sold
                        </span> */}
                    </div>
                </Link>

                {/* side option */}
                <div>
                    {
                        click ? (
                            <AiFillHeart
                                size={18}
                                className="cursor-pointer absolute right-2 top-5"
                                onClick={() => removeFromWishlistHandler(data)}
                                color={click ? "red" : "#333"}
                                title='Remove from wishlist'
                            />
                        ) : (
                            <AiOutlineHeart
                                size={18}
                                className="cursor-pointer absolute right-2 top-5"
                                onClick={() => addToWishlistHandler(data)}
                                color={click ? "red" : "#333"}
                                title='Add to wishlist'

                            />
                        )}
                    <AiOutlineEye
                        size={18}
                        className="cursor-pointer absolute right-2 top-14"
                        onClick={() => setOpen(!open)}
                        color="#333"
                        title='Quick view'
                    />

                    <AiOutlineShoppingCart
                        size={20}
                        className={`absolute right-2 top-24 ${isOwnProduct ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                        onClick={() => addToCartHandler(data._id)}
                        color={isOwnProduct ? "#999" : "#444"}
                        title={isOwnProduct ? "You cannot buy your own product" : 'Add to cart'}
                    />
                    {open ? <ProductDetailsCard setOpen={setOpen} data={data} /> : null}
                </div>
            </div>
        </>
    )
}

export default ProductCard